module.exports = __webpack_public_path__ + "img/img_security_pattern.84fe2b15.png";